import { api } from "../../../api/apiSlice";

// One row per CUSTOMER ITEM, already traced across quotation, LPO, Stock-In and
// Stock-Out by the server. Totals and variances are folded client-side from
// these same rows (same approach as the Technician Duty Report), so the summary
// and the detail can never disagree with each other.
//
// `branchId` here is the global branch filter (useBranchFilter). It narrows on
// each DOCUMENT's own branch; the caller's permitted branches are applied
// server-side from the token regardless, so omitting it never widens access.
export const reconciliationApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getTransactionReconciliation: builder.query({
      query: (params) => ({ url: "/reports/transaction-reconciliation", params }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetTransactionReconciliationQuery } = reconciliationApi;
